export default __webpack_public_path__ + "static/media/Tamra.3a97eb88.jpg";